var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCart = function SvgCart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75033 25.0715C10.3486 25.0715 10.8337 24.6558 10.8337 24.1429C10.8337 23.6301 10.3486 23.2144 9.75033 23.2144C9.15202 23.2144 8.66699 23.6301 8.66699 24.1429C8.66699 24.6558 9.15202 25.0715 9.75033 25.0715Z",
    stroke: "#333232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 25.0715C22.2647 25.0715 22.7497 24.6558 22.7497 24.1429C22.7497 23.6301 22.2647 23.2144 21.6663 23.2144C21.068 23.2144 20.583 23.6301 20.583 24.1429C20.583 24.6558 21.068 25.0715 21.6663 25.0715Z",
    stroke: "#333232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08301 0.928711H5.41634L8.31967 15.8486C8.41873 16.3616 8.69008 16.8225 9.08619 17.1504C9.48229 17.4783 9.97793 17.6526 10.4863 17.6426H21.0163C21.5247 17.6526 22.0204 17.4783 22.4165 17.1504C22.8126 16.8225 23.084 16.3616 23.183 15.8486L24.9163 6.5H6.49967",
    stroke: "#333232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cart.de2db387430735a3e73d808278a5bce8.svg";